import { useCallback, useId, useRef, useState } from 'react';
import { Button, Input } from '@swordhealth/ui-corporate';
import styled from 'styled-components';
import useBetterMediaQuery from '@/utils/useBetterMediaQuery';
import theme from '@/utils/styles-variables';

const FileUpload = ({
  id,
  accept,
  placeholder,
  label,
  errorMessage,
  helperMessage,
  formik,
  multiple = false,
  name,
  ...props
}) => {
  const fileInputEl = useRef(null);
  const fakeInputEl = useRef(null);
  const [fileNames, setFileNames] = useState([]);
  const isDesktop = useBetterMediaQuery(`(min-width: ${theme.breakpoints.min_lg}px)`);

  const updateFile = useCallback(
    async (filesList) => {
      const parsedFiles = await Promise.all(Array.from(filesList).map((file) => file));

      setFileNames(parsedFiles.map((file) => file.name));

      formik.setFieldValue(name, multiple ? parsedFiles : parsedFiles[0]);

      fakeInputEl.current?.focus();
    },
    [formik, multiple],
  );

  return (
    <>
      <Fieldset onClick={() => fileInputEl.current?.click()}>
        <div>
          <FileInput
            ref={fileInputEl}
            className="file-input"
            {...(accept ? { accept: accept.join(',') } : {})}
            name={name}
            onChange={async (e) => {
              const filesList = e.target.files;

              await updateFile(filesList);
            }}
            id={useId()}
            multiple={multiple}
            type="file"
          />
          <FakeInput
            id={id}
            ref={fakeInputEl}
            type="text"
            label={label}
            required={props.required}
            placeholder={placeholder}
            errorMessage={errorMessage}
            helperMessage={helperMessage}
            className="fake-input"
            value={fileNames.join(', ')}
            aria-hidden="true"
            tabIndex="-1"
            readOnly
            suffix={
              <Button
                id={`${id}-button`}
                as="span"
                variant={isDesktop ? 'white' : 'tertiary'}
                className="file-button"
              >
                Procurar
              </Button>
            }
          />
        </div>
      </Fieldset>
    </>
  );
};

export default FileUpload;
const Fieldset = styled.fieldset`
  &:hover {
    cursor: pointer;

    .file-button {
      background-color: var(--ui-button-hover-background-white);
      color: var(--button-hover-color);
      border-color: var(--ui-button-hover-background-white);
    }
  }
`;

const FileInput = styled.input`
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
`;

const FakeInput = styled(Input)`
  pointer-events: none;
  cursor:pointer;
  padding-top: 8px;
  padding-bottom: 8px;

  & > div:first-of-type {
    padding-top: 8px;
    padding-bottom: 8px;    
`;
